import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {DatasetModel} from '../../models/dataset.model';
import {Router} from '@angular/router';

@Component({
  selector: 'cs-report-detail',
  templateUrl: './report-detail.component.html',
  styleUrls: ['./report-detail.component.scss']
})
export class ReportDetailComponent implements OnInit, OnChanges {
  @Input() Data: DatasetModel[];


  constructor(public router: Router) {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: { [propKey: string]: any }) {
    this.Data = changes.Data.currentValue;
    if (this.Data) {
      this.Data.sort((a, b) => b.date.getTime() - a.date.getTime());
    }
  }

  goProfile(id: any) {
    this.router.navigateByUrl('/activity/profile/' + id);
  }

}
